import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
// PN1 / DC-4 — the service worker, registered from the entry point rather than from a component, so
// it happens once per page load whatever the app renders. Its update strategy (the four pieces her
// order requires in the same commit) lives in src/lib/pwa.ts and src/pwaUpdate.js.
import { registerServiceWorker, reloadOnNewDeploy } from "./lib/pwa";
// ITEM 6 — THE THEME IS PAINTED BEFORE THE FIRST FRAME, from the device cache. The account is the
// truth and App corrects this the moment `/api/room/state` answers; this line exists so a member who
// chose Light does not get a black flash on every single page load while that round trip happens.
import { applyTheme, readStoredTheme } from "./theme.js";
// ITEM 14(c) — and HER LANGUAGE, for the same reason and with one difference that matters: nothing
// cached answers NULL rather than "en" (R18), and index.html already ships a static `lang="en"`. So
// a member with no cached choice is left with the document's own honest tag instead of having the
// default written over it here, and a member who chose Spanish gets `lang="es"` before the first
// frame — which is the attribute a screen reader takes its PRONUNCIATION from.
import { applyLanguage, readStoredLanguage } from "./language.js";
import { safeLocalStorage } from "./lib/safe-storage";
// IT #319 — inside an app's own browser a download goes nowhere and says nothing, so the ONE
// transport is told once, here, which browser this is (src/lib/downloads.ts holds the why).
import { setDownloadEnvironment } from "./lib/downloads";
import { cannotSaveFiles } from "./clientBeacon.js";
// ITEM G2 — THE STORE APP. The same front end, carried inside the phone; in the website build APP_MODE
// is false and nothing below changes a thing. In the app every "/api/..." is pointed at the server.
import { APP_MODE, installServerBase } from "./lib/appMode";

if (APP_MODE) installServerBase(window);
// ITEM K1 (her TestFlight test: "the top is cut off"): the app draws under the status bar and the camera cutout, so its
// styles keep every bar inside the phone's safe area. Marked here, in the app build only; the website never carries it.
if (APP_MODE) document.documentElement.classList.add("is-store-app");

applyTheme(document.documentElement, readStoredTheme(safeLocalStorage()));
setDownloadEnvironment({ cannotSaveFiles: cannotSaveFiles(navigator.userAgent) });
const cachedLanguage = readStoredLanguage(safeLocalStorage());
if (cachedLanguage) applyLanguage(document.documentElement, cachedLanguage);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The store app ships its pages inside the phone and is updated through the store, so it registers no
// service worker and does not reload itself on a website deploy.
if (!APP_MODE) {
  registerServiceWorker();
  // Q3: an installed app that comes back after a deploy loads the new version.
  reloadOnNewDeploy();
}
